import { render } from "./SceletonNewsPreview.vue?vue&type=template&id=057c62f6&scoped=true"
import script from "./SceletonNewsPreview.vue?vue&type=script&lang=js"
export * from "./SceletonNewsPreview.vue?vue&type=script&lang=js"

import "./SceletonNewsPreview.vue?vue&type=style&index=0&id=057c62f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057c62f6"]])

export default __exports__